import { defineModuleEvidenceContract } from './moduleEvidenceContract';
import { SGA_SPEND_SCHEMA_VERSIONS } from './schemaVersions';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';

const professionalFeesEvidenceEntry =
  SGA_SPEND_MODULE_EVIDENCE_CONTRACT.entries.professional_fees;

export const PROFESSIONAL_FEES_STATE_KEYS = {
  governedSnapshot: professionalFeesEvidenceEntry.stateKey,
  spendAttested: 'professional_fees_spend_attested',
  spendGoverned: 'professional_fees_spend_governed',
  addressableAttested: 'professional_fees_addressable_attested',
  addressableGoverned: 'professional_fees_addressable_governed',
  programAttested: 'professional_fees_program_attested',
  programGoverned: 'professional_fees_program_governed',
  spendSnapshot: 'professional-fees-spend-snapshot',
  addressableSnapshot: 'professional-fees-addressable-snapshot',
  programSnapshot: 'professional-fees-program-snapshot',
} as const;

export const PROFESSIONAL_FEES_EVIDENCE_KEYS = {
  governedSnapshot: professionalFeesEvidenceEntry.evidenceKey,
  spendSnapshot: PROFESSIONAL_FEES_STATE_KEYS.spendSnapshot,
  addressableSnapshot: PROFESSIONAL_FEES_STATE_KEYS.addressableSnapshot,
  programSnapshot: PROFESSIONAL_FEES_STATE_KEYS.programSnapshot,
} as const;

export const PROFESSIONAL_FEES_BINDING_PLACEHOLDERS = {
  opportunityUsd: professionalFeesEvidenceEntry.bindingPlaceholders[0],
} as const;

export const PROFESSIONAL_FEES_SCHEMA_VERSIONS = {
  manifest: SGA_SPEND_SCHEMA_VERSIONS.manifest,
  governedSnapshot: professionalFeesEvidenceEntry.schemaVersion,
} as const;

export const PROFESSIONAL_FEES_MODULE_EVIDENCE_CONTRACT =
  defineModuleEvidenceContract(
    'professional-fees',
    {
      governed_snapshot: professionalFeesEvidenceEntry,
    },
    {
      evidenceKeys: Object.values(PROFESSIONAL_FEES_EVIDENCE_KEYS),
      sourceClasses: [professionalFeesEvidenceEntry.sourceClass],
      contextKinds: [professionalFeesEvidenceEntry.contextKind],
      schemaVersions: Object.values(PROFESSIONAL_FEES_SCHEMA_VERSIONS),
      stateKeys: Object.values(PROFESSIONAL_FEES_STATE_KEYS),
      bindingPlaceholders: Object.values(
        PROFESSIONAL_FEES_BINDING_PLACEHOLDERS,
      ),
    },
  );

export type ProfessionalFeesModuleEvidenceContract =
  typeof PROFESSIONAL_FEES_MODULE_EVIDENCE_CONTRACT;
